export default __webpack_public_path__ + "static/media/m7.796ebf07.png";